import { TenantCRMAvailable } from '@/store/modules/app/types'
import { TenantHelpers } from '@/utils/tenant-helpers'
import { SubscriptionConst } from './subscription'

export namespace TenantConst {
  export enum auth0ProfileKeys {
    uid = 'https://jig.space/jiguserid',
    tenants = 'https://jig.space/jigtenants',
  }

  export enum defaultTenantsPagination {
    page = 1,
    limit = 100,
    name = '',
  }

  const defaultCRMAvailables: TenantCRMAvailable = {
    SSOConnectionId: {
      Name: 'SSOConnectionId',
      Type: SubscriptionConst.FlexFeatureFieldType.string,
      Default: '',
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description:
        'Auth0 SSO connection ID (canonical key). If this value is set it denotes the tenant uses SSO for login based on this connection.',
      Label: 'SSO Connection ID',
      Tooltip: 'The Auth0 connection ID used for enterprise SSO authentication.',
      SyncField: '',
    },
    SSOConnectionName: {
      Name: 'SSOConnectionName',
      Type: SubscriptionConst.FlexFeatureFieldType.string,
      Default: '',
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Auth0 SSO connection name (cached for /authorize?connection=...).',
      Label: 'SSO Connection Name',
      Tooltip: 'Cached connection name for Auth0 authorization requests.',
      SyncField: '',
    },
    SSODomains: {
      Name: 'SSODomains',
      Type: SubscriptionConst.FlexFeatureFieldType.string,
      Default: '',
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Comma-separated list of HRD domains for SSO connection (cached from Auth0).',
      Label: 'SSO Domains',
      Tooltip: 'Home Realm Discovery domains associated with this SSO connection.',
      SyncField: '',
    },
    SSOLastSyncedAt: {
      Name: 'SSOLastSyncedAt',
      Type: SubscriptionConst.FlexFeatureFieldType.string,
      Default: '',
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Timestamp of last sync with Auth0 Management API.',
      Label: 'SSO Last Synced',
      Tooltip: 'When the SSO connection data was last refreshed from Auth0.',
      SyncField: '',
    },
    SSOStrategy: {
      Name: 'SSOStrategy',
      Type: SubscriptionConst.FlexFeatureFieldType.string,
      Default: '',
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Auth0 SSO strategy type (e.g., waad, samlp, oidc, okta).',
      Label: 'SSO Strategy',
      Tooltip: 'The authentication strategy used by the Auth0 connection.',
      SyncField: '',
    },
    SSOType: {
      Name: 'SSOType',
      Type: SubscriptionConst.FlexFeatureFieldType.string,
      Default: '',
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Type of SSO is being used by the customer.',
      Label: 'SSO Type',
      Tooltip: 'What type of SSO service is being used by the customer, e.g. Microsoft Azure.',
      SyncField: '',
    },
    Tags: {
      Name: 'Tags',
      Type: SubscriptionConst.FlexFeatureFieldType.string_array,
      Default: [],
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Custom tags for tenant metadata.',
      Label: 'Customer Tags',
      Tooltip: 'Add one or more labels for internal filtering or segmentation.',
      SyncField: '',
    },
    VIP: {
      Name: 'VIP',
      Type: SubscriptionConst.FlexFeatureFieldType.bool,
      Default: false,
      AddUnsetValue: false,
      Operators: [SubscriptionConst.FlexFeatureFieldOperators.eq],
      Description: 'Indicates if the tenant is a VIP customer.',
      Label: 'VIP Customer',
      Tooltip: 'Marks the tenant as high-priority for support and engagement.',
      SyncField: '',
    },
  }

  export const defaultTenant = {
    Active: false,
    ID: TenantHelpers.InvalidTenantID,
    Name: 'Team Name',
    UserCount: 0,
    CreatedAt: new Date(),
    ColorHex1: TenantHelpers.TenantDefaultColor1Hex,
    ColorHex2: TenantHelpers.TenantDefaultColor2Hex,
    Logourl: '',
    LogoImage: '',
    CRM: {
      Available: defaultCRMAvailables,
      DynamicData: {
        SSOConnectionId: '',
        SSOConnectionName: '',
        SSODomains: '',
        SSOLastSyncedAt: '',
        SSOStrategy: '',
        SSOType: '',
        Tags: [],
        VIP: false,
      },
    },
    Subscription: SubscriptionConst.defaultSubscription,
    JigFinishedCustomLink: '',
    LogoUpdated: false,
  }

  export const CRMEditableFields = ['SSOConnectionId']

  export const tenantUsersEvents = {
    showInviteModal: 'tenant-users-show-invite-modal',
  }
}
